var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "b-navbar",
    { staticClass: "main-menu" },
    [
      _c("b-navbar-brand", { attrs: { href: "#" } }, [
        _c("img", {
          staticClass: "logo",
          attrs: { src: require("@/assets/logo.png") }
        }),
        _vm._v("\n    " + _vm._s(_vm.$t("menu.appName")) + "\n  ")
      ]),
      _vm._v(" "),
      !_vm.isAppEmbedded
        ? _c(
            "b-navbar-nav",
            { staticClass: "ml-auto" },
            [
              _c(
                "b-nav-item-dropdown",
                { attrs: { text: _vm.language } },
                _vm._l(_vm.languages, function(lang) {
                  return _c(
                    "b-dropdown-item",
                    {
                      key: lang,
                      attrs: { value: "lang", active: lang === _vm.language },
                      on: {
                        click: function($event) {
                          _vm.setLanguage(lang)
                        }
                      }
                    },
                    [_vm._v("\n        " + _vm._s(lang) + "\n      ")]
                  )
                })
              ),
              _vm._v(" "),
              _c("b-nav-text", [_vm._v("  ")]),
              _vm._v(" "),
              _vm.hasUser
                ? _c(
                    "b-nav-item",
                    [
                      _c(
                        "router-link",
                        { attrs: { to: "/logout" } },
                        [_c("icon", { attrs: { name: "sign-out" } })],
                        1
                      )
                    ],
                    1
                  )
                : _vm._e()
            ],
            1
          )
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-beffe230", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-beffe230","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/MainMenu.vue
// module id = null
// module chunks = 